import React, { useState } from 'react';
import { Paper, Typography, TextField, Button, Box } from '@mui/material';
import { PDFDownloadLink, Document, Page, Text } from '@react-pdf/renderer';

const PrescriptionPDF = ({ prescription }) => (
  <Document>
    <Page>
      <Text> Doctor: {prescription.doctor} </Text>{' '}
      <Text> Date: {prescription.date} </Text>{' '}
      <Text> Patient: {prescription.patient} </Text>{' '}
      <Text> Medication: {prescription.medication} </Text>{' '}
      <Text> Instructions: {prescription.instructions} </Text>{' '}
    </Page>{' '}
  </Document>
);

const Prescribe = () => {
  const [prescription, setPrescription] = useState({
    doctor: 'Dr. John Doe',
    date: new Date().toLocaleDateString(),
    patient: '',
    medication: '',
    instructions: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrescription((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant='h6'> Prescribe </Typography>{' '}
      <Box component='form' sx={{ mt: 2 }}>
        <TextField
          label='Patient Name'
          name='patient'
          fullWidth
          value={prescription.patient}
          onChange={handleChange}
        />{' '}
        <TextField
          label='Medication'
          name='medication'
          fullWidth
          multiline
          rows={2}
          sx={{ mt: 2 }}
          value={prescription.medication}
          onChange={handleChange}
        />{' '}
        <TextField
          label='Instructions'
          name='instructions'
          fullWidth
          multiline
          rows={2}
          sx={{ mt: 2 }}
          value={prescription.instructions}
          onChange={handleChange}
        />{' '}
        <Box sx={{ mt: 2 }}>
          <PDFDownloadLink
            document={<PrescriptionPDF prescription={prescription} />}
            fileName='prescription.pdf'
          >
            {({ loading }) => (
              <Button variant='contained' color='primary'>
                {' '}
                {loading ? 'Generating PDF...' : 'Complete Prescription'}{' '}
              </Button>
            )}{' '}
          </PDFDownloadLink>{' '}
        </Box>{' '}
      </Box>{' '}
    </Paper>
  );
};

export default Prescribe;
